import { memo } from "react";
import { useLocation, useParams } from "react-router";
import { useReportListActions, useReportListSearchFilter, useReportListShouldClearInput, useReportListLayout } from "~/store/reportListStore";
import { useReportCRUD } from "~/hooks/useReportCRUD";
import { SearchInput } from "~/components/SearchInput";
import { useSearchInput } from "~/hooks/useSearchInput";
import { Button } from "snap-design-system";
import { LayoutGrid, Rows3, List as ListIcon, } from "lucide-react";

function Toolbar() {
  const { folderId } = useParams<{ folderId?: string }>();
  const { setSearchFilter, clearSearchFilter, resetShouldClearInput, setLayout } = useReportListActions();
  const { invalidateToInitialPage } = useReportCRUD(folderId || null);
  const searchFilter = useReportListSearchFilter();
  const shouldClearInput = useReportListShouldClearInput();
  const layout = useReportListLayout();
  const location = useLocation();

  const {
    inputValue,
    inputRef,
    handleChange,
    handleKeyDown,
    clearInput,
  } = useSearchInput({
    searchFilter,
    shouldClearInput,
    setSearchFilter,
    clearSearchFilter,
    resetShouldClearInput,
    onSearch: async (_value: string, shouldInvalidate = true) => {
      if (shouldInvalidate) {
        await invalidateToInitialPage();
      }
    },
    onClear: async () => {
      await invalidateToInitialPage();
    },
    minSearchLength: 3,
    placeholder: "Procurar nos relatórios",
    requireAuth: true,
  });

  const handleToggleLayout = () => {
    setLayout(layout === "masonry" ? "column" : "masonry");
  };

  const renderContent = () => {
    if (location.pathname !== "/" && !location.pathname.startsWith("/pasta/")) {
      return null;
    }

    return (
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-4 md:gap-8 w-full md:w-auto">
          <div className="mt-1.5 w-full md:w-auto md:min-w-[30dvw] md:max-w-[40dvw]" id="search-input" data-testid="search-input-list">
            <SearchInput
              ref={inputRef}
              value={inputValue}
              placeholder="Digite e pressione Enter para buscar"
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              onClear={clearInput}
              data-testid="search-input-list"
            />
          </div>
          {/* receber componente de select se for passado */}
          {/* <div className="flex-1/4">
            <Select
              options={[
                { value: "1", label: "TODOS" },
                { value: "2", label: "RELATÓRIOS" },
                { value: "3", label: "PASTAS" },
              ]}
              value={selectFilterType}
              onChange={setSelectFilterType}
            />
          </div> */}
        </div>

        <div className="flex items-center justify-end gap-2">
          <Button
            variant="ghost"
            size="small"
            onClick={handleToggleLayout}
            aria-label={layout === "masonry" ? "Alternar para layout em coluna" : "Alternar para layout em grade"}
          >
            {layout === "masonry" ? <LayoutGrid size={32} /> : <ListIcon size={32} />}
          </Button>
        </div>
      </div>
    );
  };

  return renderContent();
}

export default memo(Toolbar);
